import { Component, OnInit, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { GPackagesModelViewModel } from 'src/app/viewmodels/g-packages/GPackagesModelViewModel';
import { ItemViewModel, ItemViewModel1 } from 'src/app/viewmodels/ItemViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { GPackageSSItemViewModel } from 'src/app/viewmodels/g-packages/GPackageSSItemViewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { of } from 'rxjs';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { GPackageItemModel, GPackagesModelModel, SaveItemRequest, SavePackageRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';


@Component({
  selector: 'app-package-view',
  templateUrl: './package-view.component.html',
  styleUrls: ['./package-view.component.scss']
})
export class PackageViewComponent implements OnInit {

  @Input() public vm: SavePackageRequest;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  private submitted = false;
  public IsDublicate: boolean = false;
  modalRef: BsModalRef;

  public cpackageTypes = 'packageTypes';
  public packageTypes: any = [];

  public cbrands: any = 'brands';
  public brands: any = [];

  public cmodels: any = 'models';
  public models: any = [];
  public modelsList: any = [];

  public citems: any = 'items';
  public items: any = [];

  public spareParts: any = [];
  public selectedSpareParts: any = [];

  public services: any = [];
  public selectedServices: any = [];

  public selectedModels: any = [];
  public selectedBrands: any = [];

  public brandsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public modelsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 4,
    allowSearchFilter: true
  };
  public itemsDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    enableCheckAll: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  name = 'GenericModel';
  id = 'id';
  checked = false;
  disabled = false;
  label = 'Toggle On/Off';
  labelledby = 'Some Other Text';
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }


  ngOnInit() {
    debugger
    this.modal_title = "Package View"
    this.vm.isGenericModel = false;
    if (this.vm == undefined) {
      this.vm = new SavePackageRequest();
      this.vm.services = [];
      this.vm.spareParts = [];
    } else {

      if (this.vm.services !== undefined && this.vm.services.length > 0) {
        this.vm.services.forEach(x => {
          this.selectedServices.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
      if (this.vm.spareParts !== undefined && this.vm.spareParts.length > 0) {
        this.vm.spareParts.forEach(x => {
          this.selectedSpareParts.push(new ItemViewModel1(x.ssItemDefining.id, x.ssItemDefining.name));
        });
      }
      if (this.vm.gPackagesModel !== undefined && this.vm.gPackagesModel.length > 0) {
        this.vm.gPackagesModel.forEach(x => {
          // if (x.brand !== undefined) {
          //   this.selectedBrands.push(new ItemViewModel1(x.brand.id, x.brand.name));
          // }
          if (x.brand !== undefined) {
            const exists = this.selectedBrands.some(b => b.id === x.brand.id);
            if (!exists) {
              this.selectedBrands.push(
                new ItemViewModel1(x.brand.id, x.brand.name)
              );
            }
          }
          if (x.model !== undefined) {
            this.selectedModels.push(new ItemViewModel1(x.model.id, x.model.name));
          }
          this.getModelsForBrands(null);
        });
      }
    }
    if (this.modal_title == undefined) {
      this.modal_title = 'Package';
    }
    this.spinner.show();
    this.getPackageTypes();
    this.getBrands();
    //this.getItems();
    this.getSparePartsAndServices();
    this.getItemtypes();
    this.getModels();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }

  onChange(e) {
    debugger
    if (e == true) {
      this.vm.isGenericModel = true;
    }
    if (e == false) {
      this.vm.isGenericModel = false;
    }
  }

  getPackageTypes() {
    this._uow.gSettingService.GetPackageTypesAsync().subscribe((res: any) => {
      this.packageTypes = res.result;
      this._uow.logger.log(res);

    }, (error) => {
      this._uow.logger.log(error);
      this.packageTypes = [];
    });
  }

  getBrands() {
    this._uow.gSettingService.GetGBrandsAsync().subscribe((res: any) => {
      this.brands = res.result;
    }, (err) => {
      this.brands = [];
      this._uow.logger.log(err);
    });
  }

  public itemTypes = [];
  public ssItemVm = new SaveItemRequest();
  getItemtypes() {
    this._uow.gSettingService.GetItemTypesAsync().subscribe((res: any) => { this.itemTypes = res.result; }, (error) => { this._uow.logger.log(error); });
  }

  getSparePartsAndServices() {
    //'Spare-Parts'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync('Spare-Parts').subscribe((res: any) => {
      this.spareParts = res.result;
    }, (err) => {
      this._uow.logger.log(err);
      this.spareParts = [];
    });
    // 'Services'
    this._uow.gSettingService.GetItemsDropDownByTypeAsync('Services').subscribe((res: any) => {
      debugger
      this.services = res.result;
    }, (err) => {
      this._uow.logger.log(err);
      this.services = [];
    });
  }

  getModels() {
    this._uow.gSettingService.GetVehicleModelsAsync().subscribe((res: any) => {
      this.modelsList = res.result;
      this.getModelsForBrands(null);
    }, (err) => this._uow.logger.log(err));
  }

  getModelsForBrands(e) {

    var ids = [];
    this.selectedBrands.forEach(b => {
      ids.push(b.id);
    });
    const selectedIds = this.selectedBrands.map(b => b.id);
    this.models = this.modelsList.filter(m => selectedIds.includes(m.brand.id));
  }


  onModelSelected(e) {
    this._uow.logger.log(e.Id);
    // let model = this.models.find(x => x.Id == e.Id);
    // if (model !== undefined) {
    //   this.vm.GItemModels.push(model);
    // }
  }

  compareFn(optionOne, optionTwo): boolean {
    if (optionOne !== undefined && optionTwo !== undefined) {
      return optionOne.id === optionTwo.id;
    }
  }


  quantityChange(e, i?) {
    e.amount = e.quantity * e.amount;
    // if (e.DescountPercentage > 0) {
    //   e.Amount = (e.Amount - ((e.DescountPercentage / 100) * e.Amount));
    // }
    this.calculateTotals();
  }
  discountChange(e, i?) {
    debugger
    let discountAMmount = ((e.discountPercentage / 100) * e.salePrice);
    e.amount = (e.salePrice - discountAMmount);
    this.calculateTotals();
  }

  amountChange(e, i?) {
    this.discountChange(e)
    //this.calculateTotals();
  }

  calculateTotals() {
    debugger
    this.vm.discountAmount = 0;
    this.vm.serviceAmount = 0;
    this.vm.packageAmount = 0;
    this.vm.services.forEach(x => {
      this.vm.serviceAmount += x.amount;
      if (x.discountPercentage > 0) {
        this.vm.discountAmount += (x.salePrice * (x.discountPercentage / 100));
      }
    });

    this.vm.partsAmount = 0;
    this.vm.spareParts.forEach(x => {
      this.vm.partsAmount += x.amount;
      if (x.discountPercentage > 0) {
        this.vm.discountAmount += (x.salePrice * (x.discountPercentage / 100));
      }
    });

    debugger

    this.vm.packageAmount = this.vm.partsAmount + this.vm.serviceAmount;
  }

  onItemSubmitted(e, mf) {
    this._uow.logger.log(e);
    if (e === true) {
      if (mf == this.cbrands) {
        this.getBrands();
      }
      if (mf == this.citems) {
        //this.getItems();
      }
      if (mf == this.cpackageTypes) {
        this.getPackageTypes();
      }
      if (mf == this.cmodels) {
        this.getModelsForBrands(e);
      }
    }
  }
  checkTagDublication(tagName) {
    debugger
    this._jq.showSpinner(true);
    this._uow.packageService.checkDublication(tagName).toPromise().then((res: any) => {
      if (res === true) {
        this.IsDublicate = false;
      } else {
        this.IsDublicate = true;
      }
      this._jq.showSpinner(false);
    }).catch((error) => {
      console.log(`Promise rejected with ${JSON.stringify(error)}`);
      this.onSubmitted.emit(this.submitted);
      this._jq.showSpinner(false);
    });
  }

  closeModal() {
    this.bsmRef.hide();
    this.onSubmitted.emit(true); // Emit event to refresh list
  }


}
